module.exports = __webpack_public_path__ + "static/ic_withdrawal_ing.590b384d.png";